import { LoaderCircle } from 'lucide-react'

import { getGuideOffset, getItemPadding } from './constants'

export function LoadingRow({ level = 0 }: { level?: number }) {
  return (
    <div
      className="relative flex h-8 items-center text-muted-foreground"
      style={{ paddingLeft: getItemPadding(level) }}
      role="status"
    >
      {Array.from({ length: level }, (_, index) => (
        <span
          key={index}
          aria-hidden="true"
          className="pointer-events-none absolute inset-y-0 w-px bg-border/70"
          style={{ left: getGuideOffset(index) }}
        />
      ))}
      <LoaderCircle className="size-4 animate-spin" aria-hidden="true" />
      <span className="sr-only">Loading</span>
    </div>
  )
}
